import * as actionTypes from "./SettingsTypes";

const INITIAL_STATE = {
  LeadssourceList: null,
  LeadsQualificationList: null,
  leadsList: null,
  departmentDDList: null,
  locationList: null,
  locationDefaultList: null,
  LeadsIndustryList: null,
  LeadsBrandList: null,
  sourceList: [],
  stageList: [],
  verticalList: [],
  statusList: [],
  taskStatusList: [],
  userRolesList: [],
  roleAuthorizationList: [],
  authorizedPages: [],
  userList: [],
  advanceSeriesList: [],
  advanceSetting: null,
  accountList: [],
  projectTypeList: [],
  projectStatusList: [],
  ticketLevelList: [],
  ticketPriorityList: [],
  ticketStatusList: [],
  departmentList: [],
  departmentDetail: null,
  notificationList: [],
  historyList: [],
  managerList: [],
  policyList: [],
  roleList: [],
  enquiryCategory: [],
  enquirySubCategory: [],
  enquiryType: [],
  enquiryPriorityList: [],
  enquiryPaymentsList: [],
  enquiryPackingStyleList: [],
  enquiryDispatchTypeList: [],
  enquiryFacstatusList: [],
  productCatList: [],
  complaintCatList: [],
  complaintSolution: [],
  complaintTypeList: [],
  complaintStatusList: [],
  modeofTransList: [],
  userById: [],
  proSubCateg: [],
  proSubCategOne: [],
  termsAndConditions: [],
  settingsFlexiStatus: [],
  settingsEnquiryStatus: [],
  settingsLeadStatus: [],
  proCategory: [],
  proCategory1: [],
  proCategory2: [],
  locationCode: [],
  notifyConfigList: [],
};

const SettingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETLEADSSOURCELIST:
      return {
        ...state,
        LeadssourceList: action.payload,
      };
    case actionTypes.SETLEADSQUALIFICATIONLIST:
      return {
        ...state,
        LeadsQualificationList: action.payload,
      };
    case actionTypes.SETLEADSLIST:
      return {
        ...state,
        leadsList: action.payload,
      };
    case actionTypes.SETTASKTYPELIST:
      return {
        ...state,
        taskTypeList: action.payload,
      };
    case actionTypes.SETDEPARTMENTDDLIST:
      return {
        ...state,
        departmentDDList: action.payload,
      };
    case actionTypes.SETLOCATIONLIST:
      return {
        ...state,
        locationList: action.payload,
      };
    case actionTypes.SETLOCATIONDEFAULTLIST:
      return {
        ...state,
        locationDefaultList: action.payload,
      };
    case actionTypes.SETLEADSINDUSTRYLIST:
      return {
        ...state,
        LeadsIndustryList: action.payload,
      };
    case actionTypes.SETLEADSBRANDLIST:
      return {
        ...state,
        LeadsBrandList: action.payload,
      };
    case actionTypes.SETSOURCELIST:
      return {
        ...state,
        sourceList: action.payload.list,
      };
    case actionTypes.SETSTAGELIST:
      return {
        ...state,
        stageList: action.payload.list,
      };
    case actionTypes.SETVERTICALLIST:
      return {
        ...state,
        verticalList: action.payload.list,
      };
    case actionTypes.SETSTATUSLIST:
      return {
        ...state,
        statusList: action.payload.list,
      };
    case actionTypes.SETTASKSTATUSLIST:
      return {
        ...state,
        taskStatusList: action.payload.list,
      };
    case actionTypes.SETUSERROLESLIST:
      return {
        ...state,
        userRolesList: action.payload.list,
      };
    case actionTypes.SETROLEAUTHORIZATIONLIST:
      return {
        ...state,
        roleAuthorizationList: action.payload,
      };
    case actionTypes.SETAUTHORIZEDPAGES:
      return {
        ...state,
        authorizedPages: action.payload.list,
      };
    case actionTypes.SETUSERLIST:
      return {
        ...state,
        userList: action.payload.Data,
      };
    case actionTypes.SETADVANCESERIESLIST:
      return {
        ...state,
        advanceSeriesList: action.payload.list,
      };
    case actionTypes.SETADVANCESETTING:
      return {
        ...state,
        advanceSetting: action.payload.list,
      };
    case actionTypes.SETACCOUNTLIST:
      return {
        ...state,
        accountList: action.payload.list,
      };
    case actionTypes.SETPROJECTTYPELIST:
      return {
        ...state,
        projectTypeList: action.payload.list,
      };
    case actionTypes.SETPROJECTSTATUSLIST:
      return {
        ...state,
        projectStatusList: action.payload.list,
      };
    case actionTypes.SETTICKETLEVELLIST:
      return {
        ...state,
        ticketLevelList: action.payload.list,
      };
    case actionTypes.SETTICKETPRIORITYLIST:
      return {
        ...state,
        ticketPriorityList: action.payload.list,
      };
    case actionTypes.SETTICKETSTATUSLIST:
      return {
        ...state,
        ticketStatusList: action.payload.list,
      };
    case actionTypes.SETDEPARTMENTLIST:
      return {
        ...state,
        departmentList: action.payload.list,
      };
    case actionTypes.SETDEPARTMENTDETAIL:
      return {
        ...state,
        departmentDetail: action.payload.list,
      };
    case actionTypes.CLEARDOC:
      return {
        ...state,
        departmentDetail: null,
      };
    case actionTypes.SETNOTIFICATIONLIST:
      return {
        ...state,
        notificationList: action.payload.list,
      };
    case actionTypes.SETHISTORYLIST:
      return {
        ...state,
        historyList: action.payload.list,
      };
    case actionTypes.SETMANAGERLIST:
      return {
        ...state,
        managerList: action.payload.list.Data,
      };
    case actionTypes.SETPOLICYLIST:
      return {
        ...state,
        policyList: action.payload.list.Data,
      };
    case actionTypes.SETROLELIST:
      return {
        ...state,
        roleList: action.payload.list.Data,
      };
    case actionTypes.SETENQUIRYCATEGORY:
      return {
        ...state,
        enquiryCategory: action.payload,
      };
    case actionTypes.SETENQUIRYSUBCATEGORY:
      return {
        ...state,
        enquirySubCategory: action.payload,
      };
    case actionTypes.SETENQUIRYTYPE:
      return {
        ...state,
        enquiryType: action.payload,
      };
    case actionTypes.SETENQUIRYPRIORITYLIST:
      return {
        ...state,
        enquiryPriorityList: action.payload,
      };
    case actionTypes.SETENQUIRYPAYMENTSLIST:
      return {
        ...state,
        enquiryPaymentsList: action.payload,
      };
    case actionTypes.SETENQUIRYPACKINGSTYLELIST:
      return {
        ...state,
        enquiryPackingStyleList: action.payload,
      };
    case actionTypes.SETENQUIRYDISPATCHTYPELIST:
      return {
        ...state,
        enquiryDispatchTypeList: action.payload,
      };
    case actionTypes.SETENQUIRYFACSTATUSLIST:
      return {
        ...state,
        enquiryFacstatusList: action.payload,
      };
    case actionTypes.SETPRODUCTCATLIST:
      return {
        ...state,
        productCatList: action.payload,
      };
    case actionTypes.SETCOMPLAINTCATLIST:
      return {
        ...state,
        complaintCatList: action.payload,
      };
    case actionTypes.SETCOMPLAINTSOLUTION:
      return {
        ...state,
        complaintSolution: action.payload,
      };
    case actionTypes.SETCOMPLAINTTYPELIST:
      return {
        ...state,
        complaintTypeList: action.payload,
      };
    case actionTypes.SETCOMPLAINTSTATUSLIST:
      return {
        ...state,
        complaintStatusList: action.payload,
      };
    case actionTypes.SETMODEOFTRANSLIST:
      return {
        ...state,
        modeofTransList: action.payload,
      };
    case actionTypes.SETUSERBYID:
      return {
        ...state,
        userById: action.payload,
      };
    case actionTypes.SETENQUIRYPROSUBCATEGORY:
      return {
        ...state,
        proSubCateg: action.payload,
      };
    case actionTypes.SETENQUIRYPROSUBCATEGORYONE:
      return {
        ...state,
        proSubCategOne: action.payload,
      };
    case actionTypes.SETTERMSANDCONDITIONS:
      return {
        ...state,
        termsAndConditions: action.payload,
      };
    case actionTypes.SETSETTINGSFLEXISTATUS:
      return {
        ...state,
        settingsFlexiStatus: action.payload,
      };
    case actionTypes.SETSETTINGSENQUIRYSTATUS:
      return {
        ...state,
        settingsEnquiryStatus: action.payload,
      };
    case actionTypes.SETSETTINGSLEADSTATUS:
      return {
        ...state,
        settingsLeadStatus: action.payload,
      };
    case actionTypes.SETPROCATEGORY:
      return {
        ...state,
        proCategory: action.payload,
      };
    case actionTypes.SETPROCATEGORY1:
      return {
        ...state,
        proCategory1: action.payload,
      };
    case actionTypes.SETPROCATEGORY2:
      return {
        ...state,
        proCategory2: action.payload,
      };
    case actionTypes.SETLOCATIONCODE:
      return {
        ...state,
        locationCode: action.payload,
      };
    case actionTypes.SETNOTIFYCONFIGLIST:
      return {
        ...state,
        notifyConfigList: action.payload.list.Data,
      };
    default:
      return state;
  }
};

export default SettingsReducer;
